const SSR_SAFE_PATH_PREFIXES = [
  '/checkout',
  '/my-account',
  '/payment',
  '/store/checkout',
] as const;

export function isSsrSafePathname(pathname: string | undefined): boolean {
  if (!pathname) return false;

  const localePattern = /^\/[a-z]{2}-[a-z]{2,3}(\/|$)/;
  const pathWithoutLocale = pathname.replace(localePattern, '/');

  return SSR_SAFE_PATH_PREFIXES.some((prefix) =>
    pathWithoutLocale.startsWith(prefix),
  );
}
